export class TreeSelectHelper {
  constructor() {}

  static updateCheckedFieldsFromSelectedNodes(arr, selectedNodes) {
    return arr?.map((item) => {
      const node = selectedNodes?.find((n) => n.value === item.value && n.parentId === item.parentId);
      return {
        ...item,
        checked: node ? node.checked : false,
        children: item.children ? this.updateCheckedFieldsFromSelectedNodes(item.children, selectedNodes) : [],
      };
    });
  }

  static filterByParentId(dropdowns, programId) {
    const results = [];

    dropdowns.forEach((dropdown) => {
      results.push({
        ...dropdown,
        children: TreeSelectHelper.filterChildrenByParentId(dropdown.children, programId),
      });
    });

    return results;
  }

  static filterChildrenByParentId(arr, programId) {
    return arr?.filter((item) => {
      if (item.treeLevel === 1 && item.parentId !== programId) {
        return false;
      }
      if (item.children && item.children.length > 0) {
        return this.filterChildrenByParentId(item.children, programId);
      }

      return true;
    });
  }

  static filterOutDisabled(arr) {
    return arr
      ?.map((item) => {
        if (item.disabled === true && item.treeLevel > 0) return null;

        return {
          ...item,
          children: item.children?.length > 0 ? this.filterOutDisabled(item.children) : [],
        };
      })
      .filter(Boolean);
  }
}
